import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Header from "@arelia-components/layout/Header";
import { ContentBox } from "@arelia-components/ui-atoms/ContentBox";
import Content from "@arelia-components/layout/Content";
import LogoutForm from "@arelia-components/api-authorization/LogoutForm";
import { Button } from "@mui/material";
import { PATHS } from "src/routes";

export default function Account() {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const navOptions = [
    { value: PATHS.PROFILE, label: "Profile" },
    { value: PATHS.CONNECTIONS, label: "Connections" },
    { value: PATHS.SUBSCRIPTION, label: "Subscription" },
    { value: PATHS.SECURITY, label: "Security" }
  ];

  useEffect(() => {
    if (pathname === PATHS.ACCOUNT) {
      navigate(PATHS.ACCOUNT + "/profile");
    }
  }, [pathname]);

  const action = <LogoutForm>
    <Button type="submit" variant="contained" color="secondary">Logout</Button>
  </LogoutForm>;

  return (
    <ContentBox>
      <Header
        title="Account"
        action={action}
        navOptions={navOptions}
        navValue={pathname}
        setNavValue={navigate}
      />
      <Content />
    </ContentBox>
  );
}
